import React from 'react';
import { IBasicEventValueFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import EntityCategoryDetails from '../../Builder/EntitySelection/details/EntityCategoryDetails';
import * as DictionaryEntityDetailsUI from './DictionaryEntityDetailsUI';

interface IProps {
  basicEvent: IBasicEventValueFieldsFragment;
}

const DictionaryBasicEventDetails = ({ basicEvent }: IProps) => {
  const eventValue = basicEvent.value;
  const tableNames = basicEvent.tableNames;

  return (
    <DictionaryEntityDetailsUI.Container>
      <DictionaryEntityDetailsUI.Description>
        {eventValue.description && (
          <>
            <DictionaryEntityDetailsUI.DescriptionTerm>
              Description:
            </DictionaryEntityDetailsUI.DescriptionTerm>
            {eventValue.description}
          </>
        )}
        {tableNames.length > 0 && (
          <>
            <DictionaryEntityDetailsUI.DescriptionTerm>
              {tableNames.length > 1 ? 'Tables' : 'Table'}:
            </DictionaryEntityDetailsUI.DescriptionTerm>
            {tableNames.join(', ')}
          </>
        )}
      </DictionaryEntityDetailsUI.Description>
      {basicEvent.categories.length > 0 && (
        <EntityCategoryDetails entityCategories={basicEvent.categories} />
      )}
    </DictionaryEntityDetailsUI.Container>
  );
};

export default DictionaryBasicEventDetails;
